import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

export default {
    createFeedback: (body) => postRequest(`/feedbacks`, body),
    findFeedback: (id) => getRequest(`/feedbacks/${id}`),
    updateFeedback: (id, body) => patchRequest(`/feedbacks/${id}`, body),
    deleteFeedback: (id) => deleteRequest(`/feedbacks/${id}`),
    findFeedbackSharedUrls: (id) => getRequest(`/feedbacks/${id}/shared-urls`),
    findFeedbackFiles: (id) => getRequest(`/feedbacks/${id}/files`),
    createFeedbackSharedUrls: (id, body) => postRequest(`/feedbacks/${id}/shared-urls`, body),
    createFeedbackFiles: (id, body) => postRequest(`/feedbacks/${id}/files`, body),
};
